import Bold from "./Bold";
import Italic from "./Italic";
import Underline from "./Underline";
import TextSize from "./TextSize";
import Tick from "./Tick";
import RemoveTextFormat from "./RemoveTextFormat";
import AlignRight from "./AlignRight";
import AlignCenter from "./AlignCenter";
import AlignLeft from "./AlignLeft";
import AlignJustifyFull from "./AlignJustifyFull";
import ListOrdered from "./ListOrdered";
import ListUnOrdered from "./ListUnOrdered";
import IncreaseIndent from "./IncreaseIndent";
import DecreaseIndent from "./DecreaseIndent";
import Link from "./Link";
import More from "./More";
import Back from "./Back";
import One from "./One";
import Two from "./Two";
import Three from "./Three";
import Four from "./Four";
import Five from "./Five";
import Six from "./Six";
import Quote from "./Quote";
import SourceCode from "./SourceCode";
import Image from "./Image";
import Video from "./Video";
import RTL from "./RTL";
import LTR from "./LTR";
import TextField from "./TextField";
import ErrorMessage from "./ErrorMessage";

const tools: Record<string, React.FC<any>> = {
    bold: Bold,
    italic: Italic,
    underline: Underline,
    textSize: TextSize,
    h1: One,
    h2: Two,
    h3: Three,
    h4: Four,
    h5: Five,
    h6: Six,
    alignRight: AlignRight,
    alignCenter: AlignCenter,
    alignLeft: AlignLeft,
    alignJustifyFull: AlignJustifyFull,
    ol: ListOrdered,
    ul: ListUnOrdered,
    increaseIndent: IncreaseIndent,
    decreaseIndent: DecreaseIndent,
    quote: Quote,
    sourceCode: SourceCode,
    image: Image,
    video: Video,
    link: Link,
    linkConfirm: Tick,
    linkField: TextField,
    removeFormat: RemoveTextFormat,
    rtl: RTL,
    ltr: LTR,
    more: More,
    back: Back,
    errorMsg: ErrorMessage,
};

export default tools;
